import type { ProductName, SportType } from '@/interface/enum';
import { useApp } from '@/libraries/composables/useApp';
import { usePlatformActions } from '@/libraries/composables/usePlatformActions';

interface ISwitchProductRequest {
    productName: ProductName;
    sportType?: SportType;
}

const { loginInApp, updateBalanceInApp } = useApp();
const { handleActionByPlatform } = usePlatformActions();

class Platform {
    updateBalance() {
        handleActionByPlatform({
            appAction: () => updateBalanceInApp(),
            webAction: () => {
                window.eventEmitter.emit('pp.updateBalance');
            },
        });
    }

    showLogin(productName: string) {
        handleActionByPlatform({
            appAction: () => loginInApp(),
            webAction: () => {
                window.eventEmitter.emit('pp.showLogin', productName);
            },
        });
    }

    logout(message: string) {
        window.eventEmitter.emit('pp.logout', message);
    }

    switchProduct(request: ISwitchProductRequest) {
        window.eventEmitter.emit('pp.switchProduct', {
            productName: request.productName,
            sportType: request.sportType,
        });
    }

    emitComponentReady(component: string) {
        window.eventEmitter.emit('pp.componentReady', component);
    }
}

export const platform = new Platform();
